define([
	"dojo/_base/declare",
	"csi/util",
	"csi/xml"
], function(declare, util, xml) {

	return declare(null, {
		// String: limit path for query
		limitPath: null,

		// Class: target reflection class of path
		rcTarget: null,

		constructor: function(def) {
			this.id = util.getProperty(def, "Id");
			this.path = util.getProperty(def, "Path");
			this.name = util.getProperty(def, "Name");
		},

		isValid: function() {
			return this.id || this.path;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			var rcPathTarget = (rcRoot && this.path) ? rcRoot.getPathClass(this.path) : rcRoot;

			this.rcTarget = (rcPathTarget && this.id) ? rcPathTarget.getChildClass(this.id) : rcPathTarget;
			this.limitPath = xml.path(this.path, this.id);

			if (this.name) {
				this.name = lr.getResource(this.name);
			} else if (rcPathTarget && this.id) {
				this.name = lr.getTypeAttribute(rcPathTarget.getType(), this.id);
			} else if (this.rcTarget && this.path) {
				this.name = lr.getTypePlural(this.rcTarget.getType());
			}

			this.name = (this.name || this.id || this.path) + "...";
		}
	});
});